import { toPng } from 'html-to-image'
import { getEmbeddedFontCss } from '@/utils/fontBase64.js'

export async function exportToPng(element, filename = {}) {
  if (!element) {
    console.error('É preciso fornecer um elemento para gerar o PNG.')
    throw new Error('Elemento não fornecido.')
  }
  if (!filename) {
    console.error('É preciso fornecer um nome de arquivo para gerar o PNG.')
    throw new Error('Nome de arquivo não fornecido.')
  }
  const fontEmbedCSS = await getEmbeddedFontCss() 
  const defaultOptions = {
    pixelRatio: 3,
    backgroundColor: '#FFFFFF',
    cacheBust: false,
    skipFonts: false,
    preferredFontFormat: 'woff2',
    fontEmbedCSS,
    style: { fontFamily: 'Rubik, sans-serif' },
  }


  try {
    const imgDataUri = await toPng(element, defaultOptions)
    const link = document.createElement('a')
    link.download = filename.endsWith('.png') ? filename : `${filename}.png`
    link.href = imgDataUri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (error) {
    console.error('Erro ao gerar PNG com fontes customizadas:', error)
    throw error
  }
}